import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { redirectHome } from 'src/app/router/paths';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { StyledLogo } from './styles';

type HeaderLogoLinkProps = {
  onClick?: () => void;
  ariaLabel?: string;
};

export const HeaderLogoLink = ({ onClick, ariaLabel }: HeaderLogoLinkProps) => {
  return (
    <StyledLogo>
      <CapsuleIcon
        onClick={onClick ?? redirectHome}
        aria-label={ariaLabel ?? "Navigate to Capsule's Home Page"}
        iconString={CAPSULE_ICON_STRINGS.capsule_logo}
        block
      />
    </StyledLogo>
  );
};
